module.exports = __webpack_public_path__ + "img/icon_chat.4c33a77a.svg";